import React from 'react';
import './StandardPagination.css';

const StandardPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  totalItems,
  itemsPerPageOptions = [10, 20, 50, 100],
  itemsPerPageLabel = "Items per page:",
  showItemsPerPage = true,
  showPageInfo = true,
  pageInfoLabel = "Showing"
}) => {
  if (totalPages <= 1) return null;

  const startItem = ((currentPage - 1) * itemsPerPage) + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      {/* Items Per Page Controls - At the Top */}
      {showItemsPerPage && (
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <label htmlFor="itemsPerPage" className="form-label me-2 mb-0">{itemsPerPageLabel}</label>
              <select 
                id="itemsPerPage"
                className="form-select"
                value={itemsPerPage}
                onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
                style={{ 
                  maxWidth: '80px', 
                  height: '32px',
                  fontSize: '14px',
                  padding: '4px 8px'
                }}
              >
                {itemsPerPageOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>
          {showPageInfo && (
            <div className="col-md-6 text-end">
              <small style={{ color: 'var(--darkOrange)' }}>
                {pageInfoLabel} {startItem} to {endItem} of {totalItems} items
              </small>
            </div>
          )}
        </div>
      )}

      {/* Pagination Navigation - At the Bottom */}
      <div className="d-flex justify-content-center mt-4">
        <nav aria-label="Pagination">
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  backgroundColor: 'var(--lightPurple)',
                  color: 'var(--darkOrange)',
                  border: '1px solid var(--lightPurple)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  if (!e.target.disabled) {
                    e.target.style.backgroundColor = 'var(--darkOrange)';
                    e.target.style.color = 'var(--darkPurple)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.target.disabled) {
                    e.target.style.backgroundColor = 'var(--lightPurple)';
                    e.target.style.color = 'var(--darkOrange)';
                  }
                }}
              >
                Previous
              </button>
            </li>
            
            {/* Page numbers */}
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
              <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                <button 
                  className="page-link" 
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  backgroundColor: 'var(--lightPurple)',
                  color: 'var(--darkOrange)',
                  border: '1px solid var(--lightPurple)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  if (!e.target.disabled) {
                    e.target.style.backgroundColor = 'var(--darkOrange)';
                    e.target.style.color = 'var(--darkPurple)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.target.disabled) {
                    e.target.style.backgroundColor = 'var(--lightPurple)';
                    e.target.style.color = 'var(--darkOrange)';
                  }
                }}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default StandardPagination;
